import React, { useEffect, useState } from "react";

const ProgramsPage = () => {
    const [programs, setPrograms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const API_URL = "https:/gp-chandoli-khurd.com/backend/api/program/get_program.php";

    useEffect(() => {
        fetch(API_URL)
            .then((res) => {
                if (!res.ok) throw new Error("Failed to fetch programs");
                return res.json();
            })
            .then((data) => {
                setPrograms(data.programs || []);
                setLoading(false);
            })
            .catch((err) => {
                console.error(err);
                setError(err.message);
                setLoading(false);
            });
    }, []);

    if (loading)
        return (
            <div className="flex items-center justify-center h-screen">
                <p className="text-gray-500 text-lg animate-pulse">
                    Loading programs...
                </p>
            </div>
        );

    if (error)
        return (
            <div className="flex items-center justify-center h-screen">
                <p className="text-red-500 text-lg">{error}</p>
            </div>
        );

    return (
        <div className="bg-gray-100 min-h-screen">
            <header className=" py-10 text-center">
                <h1 className="text-4xl md:text-5xl font-extrabold">
                    ग्रामपंचायत कार्यक्रम
                </h1>
                <p className="text-green-100 mt-2 text-lg md:text-xl">
                    सर्व चालू व आगामी कार्यक्रम येथे पहा
                </p>
            </header>

            <main className="max-w-5xl mx-auto py-6 px-4 space-y-12">
                {programs.length === 0 ? (
                    <p className="text-center text-gray-600 text-lg">
                        कोणतेही कार्यक्रम उपलब्ध नाहीत.
                    </p>
                ) : (
                    programs.map((prog) => (
                        <section
                            key={prog.id}
                            className="w-full bg-white rounded-xl shadow-lg overflow-hidden"
                        >
                            {/* Media */}
                            {prog.photo && (
                                <img
                                    src={prog.photo}
                                    alt={prog.title}
                                    className="w-full h-64 object-cover"
                                />
                            )}
                            {prog.video && (
                                <video
                                    controls
                                    className="w-full h-64 object-cover"
                                >
                                    <source src={prog.video} type="video/mp4" />
                                    तुमचा browser video support करत नाही.
                                </video>
                            )}

                            {/* Details */}
                            <div className="p-6">
                                <h2 className="text-2xl font-bold mb-3 text-gray-800">
                                    {prog.title}
                                </h2>

                                <p className="text-gray-700 mb-1">
                                    <span className="font-medium">तारीख:</span> {prog.program_date}
                                </p>
                                {prog.time && (
                                    <p className="text-gray-700 mb-1">
                                        <span className="font-medium">वेळ:</span> {prog.time}
                                    </p>
                                )}
                                {prog.location && (
                                    <p className="text-gray-700 mb-1">
                                        <span className="font-medium">स्थळ:</span> {prog.location}
                                    </p>
                                )}
                                {prog.organizer && (
                                    <p className="text-gray-700 mb-1">
                                        <span className="font-medium">आयोजक:</span> {prog.organizer}
                                    </p>
                                )}
                                {prog.target_audience && (
                                    <p className="text-gray-700 mb-1">
                                        <span className="font-medium">Target Audience:</span>{" "}
                                        {prog.target_audience}
                                    </p>
                                )}

                                {prog.description && (
                                    <p className="text-gray-700 mt-2">{prog.description}</p>
                                )}

                                {prog.pdf && (
                                    <a
                                        href={prog.pdf}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="text-blue-600 mt-3 inline-block font-medium hover:underline"
                                    >
                                        PDF डाउनलोड करा
                                    </a>
                                )}
                            </div>
                        </section>
                    ))
                )}
            </main>
        </div>
    );
};

export default ProgramsPage;